// extracted by mini-css-extract-plugin
module.exports = {"rowDragging":"AssignedLegsTable_rowDragging__11RlJ","dragVisible":"AssignedLegsTable_dragVisible__3CFe8","dragHandleIcon":"AssignedLegsTable_dragHandleIcon__3S1o5"};